/**
 * Utility function to merge class names conditionally
 * Simple implementation without external dependencies
 */
export function cn(...inputs: (string | undefined | null | false)[]) {
  return inputs.filter(Boolean).join(' ');
}

